import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import { useSelector } from 'react-redux';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { useDefinedAttributes } from '../DefinedAttributesContext';
import useDefinedAttributeValidation from './useDefinedAttributeValidation';
import LinkifiedText from './LinkifiedText';

// OperatorConnectAuthPolicyField-like for VendorDefined list attribute, but context controlled
export default function ListAttribute({ attribute, index }) {
    const [isHovered, setIsHovered] = useState(false);
    const validation = JSON.parse(attribute.definedAttributeValidationType);
    const { darkMode } = useSelector((state) => state.settings);
    const validValues = (validation.ValidValues || '')
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value !== '')
        .map((value) => ({ id: value, name: value }));
    const { attributesErrors } = useDefinedAttributes();
    const errorObj = attributesErrors.find((obj) => obj.id === index);
    const error = errorObj ? errorObj.message : '';
    const { handleAttributeChange, removeAttributeError } =
        useDefinedAttributeValidation();
    const handleChange = (item) => {
        removeAttributeError(index);
        handleAttributeChange(item ? item.id : '', index);
    };
    return (
        <FormControl
            isRequired={validation.Required}
            isInvalid={!!error}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            paddingTop: 0,
                            whiteSpace: 'normal',
                            overflow: 'visible',
                        }}>
                        {attribute.name}
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        <LinkifiedText
                            text={
                                attribute?.description ||
                                'Select a value for this attribute.'
                            }
                        />
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <DropDown
                            currentId={attribute.value}
                            data={validValues}
                            shownValue="name"
                            alphabetical={false}
                            handleSelectChange={handleChange}
                            placeholder="Please select an option"
                            darkMode={darkMode}
                            width="100%"
                            noPadding
                        />
                        <FormErrorMessage
                            display="flex"
                            sx={{ marginTop: '0 !important', fontSize: '10px' }}
                            justifyContent="flex-end">
                            {error || ''}
                        </FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={
                            attribute?.description ||
                            'Select a value for this attribute.'
                        }
                        ariaLabel="vendor-defined-list-attribute-tip"
                        left="25px"
                        top="10px"
                    />
                )}
            </Stack>
        </FormControl>
    );
}
